import { Component, Input } from '@angular/core';
import { Charge } from '../../models/charge.model';
import { ChargeService } from '../../services/charge.service';
import moment from 'moment';

@Component({
  selector: 'app-charge-item',
  templateUrl: './charge-item.component.html',
  styleUrl: './charge-item.component.scss'
})
export class ChargeItemComponent {

  @Input() charge?: Charge;
  @Input() duplicateIndex?: number;

  constructor(
    private chargeService: ChargeService,
  ) { }

  /*
  ██████╗ ███████╗██╗     ███████╗████████╗███████╗
  ██╔══██╗██╔════╝██║     ██╔════╝╚══██╔══╝██╔════╝
  ██║  ██║█████╗  ██║     █████╗     ██║   █████╗
  ██║  ██║██╔══╝  ██║     ██╔══╝     ██║   ██╔══╝
  ██████╔╝███████╗███████╗███████╗   ██║   ███████╗
  ╚═════╝ ╚══════╝╚══════╝╚══════╝   ╚═╝   ╚══════╝

  */
  async delete() {

    const month = moment(
      this.charge!.createdAt
    ).format('MMMM');

    const suffix = this.duplicateIndex ? ` #${this.duplicateIndex}` : '';
    const flag = confirm(
      `¿Estás seguro que deseas borrar el cobro de ${month}${suffix}?`
    );

    if (flag) {
      await this.chargeService.delete(this.charge!);
    }

  }

}
